import './src/styles/reset.css';

export const onRouteUpdate = ({ location, prevLocation }) => {
    // scroll to top on every route change
    document.body.scrollTop = 0;
}